'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { PatternSelectPage } from './-components/PatternSelectPage';
export const Route = createFileRoute('/_staff/labor-core/_egov-mock/egov-offboarding/')({
  component: PatternSelectPage
});